export default {
    'welcome-text': 'أهلا بك في نظام إدارة الملفات Acacia',
    'select-company': 'اختر شركة',
}